import React, { useState } from 'react'
import { Container, Wrapper, Form, FormTitle, FormContainer, FormRow, FormItem, FormCheckBox, FormMessage, FormTermsAndConditions, ButtonSend, ImgContainer, ButtonContainer } from '../../components/ContactSectionsElements';
import contactImg from '../../assets/images/contact.png';
import InputPhoneNumber from '../../components/InputPhoneNumber';
import { useTranslation } from 'react-i18next';
import CustomCheckbox from '../../components/CustomCheckbox';
import { errorNotification, successNotification, warningNotification } from '../../utils/toastNotifications';
import axios from 'axios';
import { API_URL } from '../../const/api';
import { Helmet } from 'react-helmet';
import {useNavigate} from 'react-router-dom';

const initialForm = {
  correo: '',
  pais: '',
  telefono: '',
  a: '',
  b: '',
  c: '',
  d: '',
  e: '',
  mensaje: '',
  terminos: false
}



const Afiliados = () => {
	const [t] = useTranslation('global');
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({
    correo: '',
    pais: '',
    telefono: '',
    a: '',
    b: '',
    c: '',
    d: '',
    e: '',
    mensaje: ''
  });

  const [countryCode, setCountryCode] = useState('+1');
  const [showOtros, setShowOtros] = useState(false);
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false);

  const selectCountryCode = (code) => setCountryCode(code);
  const handleChange = (e) => {
    const {name, value} = e.target;
    setForm({
      ...form,
      [name]: value
    });
    if(name==='a') {
      value==='otro' ? setShowOtros(true) : setShowOtros(false)
    }
  }

  const handleCountry = (val) => {
    setCountryCode(val)
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(!form.correo) return errorNotification(t('alert.errorNotificationRetiro-56'), 'top-center');
    if(!form.telefono) return errorNotification(t('alert.errorNotificationRetiro-57'), 'top-center');
    if(!form.pais) return errorNotification(t('alert.errorNotificationRetiro-58'), 'top-center');
    if(!form.a) return errorNotification(t('alert.errorNotificationRetiro-59'), 'top-center');
    if(!form.b) return errorNotification(t('alert.errorNotificationRetiro-60'), 'top-center');
    if(form.b==='si') {
      if(!form.c) return errorNotification(t('alert.errorNotificationRetiro-61'), 'top-center');
    }
    if(!form.d) return errorNotification(t('alert.errorNotificationRetiro-62'), 'top-center');
    if(form.d==='si') {
      if(!form.e) return errorNotification(t('alert.errorNotificationRetiro-63'), 'top-center');
    }
    if(!form.mensaje) return errorNotification(t('alert.errorNotificationRetiro-64'), 'top-center');
    if(!form.terminos) return errorNotification(t('alert.errorNotificationRetiro-65'), 'top-center');
    setLoading(true);
    const res = await axios.post(API_URL+'afiliados', {...form, telefono: countryCode+form.telefono});
    if(res.data.status===1) {
      setLoading(false);
      successNotification(t('alert.successNotification-9'), 'top-center');
      setForm(initialForm);
      setTimeout(()=>{
        const scrollafiliado = document.getElementById("root");
        scrollafiliado.scrollIntoView({ behavior: "smooth" });
        navigate('/')
      },1000)
    } else {
      setLoading(false);
      errorNotification(t('alert.errorNotificationRetiro-66'), 'top-center');
    }
  }

  const handleCheck = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.checked
    })
  }

  return (
    <Container>
      <Helmet>
				<title>MasterBets365</title>
			</Helmet>
      <Wrapper>
        <FormContainer>
          <FormTitle>
            <h2>ASOCIADOS Y FRANQUICIAS</h2>
            <p>Gracias por tu interés. A continuación completa el siguiente formulario y un ejecutivo de ventas de MasterBets365 te contactará.</p>
          </FormTitle>
          <Form onSubmit={handleSubmit}>
            <FormRow>
              <FormItem>
                <label>{t('contact.lbl-email')}</label>
                <input type='text' name='correo' value={form.correo} onChange={handleChange} placeholder={t('contact.lbl-email')} required />
              </FormItem>
              <FormItem>
              <InputPhoneNumber
                  handleChange={handleChange}
                  handleCountry={handleCountry}
                  selectCountryCode={selectCountryCode}
                  value={form.telefono} />
              </FormItem>
            </FormRow>
            <FormRow>
              <FormItem>
                <label>País/Ciudad/Zona desde donde nos contactas:</label>
                <input type='text' name='pais' value={form.pais} onChange={handleChange} placeholder='País/Ciudad/Zona' required />
              </FormItem>
              <FormItem>
              </FormItem>
            </FormRow>
            <FormCheckBox>
              <label className='title'>¿Cómo supiste sobre nosotros?</label>
              <label htmlFor='yes' className='form-control'>
                <CustomCheckbox type='radio' name='a' id='yes' value='Por un amigo' onChange={handleChange} />
                Por un amigo.
              </label>

              <label htmlFor='no' className='form-control'>
              <CustomCheckbox type='radio' name='a' id='no' value='Redes Sociales' onChange={handleChange} />
              Redes Sociales.
              </label>

              <label htmlFor='sede' className='form-control'>
              <CustomCheckbox type='radio' name='a' id='sede' value='Alguna sede de MasterBets365' onChange={handleChange} />
              Alguna sede de MasterBets365.
              </label>

              <label htmlFor='otro' className='form-control'>
              <CustomCheckbox type='radio' name='a' id='otro' value='otro' onChange={handleChange} />
              Otro:
              </label>
              {showOtros && 
                <FormRow>
                  <FormItem>
                  <input type='text' name='a' onChange={handleChange} value={showOtros ? '' : form.a} placeholder='Escriba su respuesta' required/>
                  </FormItem>
                  <FormItem></FormItem>
                </FormRow>
              }
              
            </FormCheckBox>
            


            <FormCheckBox>
              <label htmlFor='isInterested' className='title'>¿Trabajas o has trabajado con alguna plataforma de apuestas deportivas?</label>
              <label htmlFor='isInterested-yes' className='form-control'>
                <CustomCheckbox type='radio' name='b' id='isInterested-yes' value='si' onChange={handleChange} />
                {t('contact.lbl-yes')}
              </label>
              <label htmlFor='isInterested-no' className='form-control'>
                <CustomCheckbox type='radio' name='b' id='isInterested-no' value='no' onChange={handleChange} />
                {t('contact.lbl-no')}
              </label>
            </FormCheckBox>
            <FormRow>
              <FormItem>
                <label>Si la respuesta anterior es "SI", descríbenos tu experiencia:</label>
                <p>¿Con cuál? ¿Volumen de ventas mensuales? </p>
                <input type='text' name='c' value={form.experiencia} onChange={handleChange} placeholder='Descríbenos tu experiencia'  />
              </FormItem>
              <FormItem>
              </FormItem>
            </FormRow>


              <FormCheckBox>
                <label htmlFor='isInterested' className='title'>¿Cuentas con algún local donde deseas establecer tu negocio de apuestas deportivas?</label>
                  <label htmlFor='local-si' className='form-control'>
                    <CustomCheckbox type='radio' name='d' id='local-si' value='si' onChange={handleChange} />
                    {t('contact.lbl-yes')}
                  </label>
                  <label htmlFor='local-no' className='form-control'>
                    <CustomCheckbox type='radio' name='d' id='local-no' value='no' onChange={handleChange} />
                    {t('contact.lbl-no')}
                  </label>

              </FormCheckBox>
              <FormCheckBox>
                <label htmlFor='isInterested' className='title'>Si la respuesta anterior es "SI", selecciona una de las siguientes opciones:</label>
                  <label htmlFor='alquilado' className='form-control'>
                    <CustomCheckbox type='radio' name='e' id='alquilado' value='Local alquilado' onChange={handleChange} />
                    Local alquilado.
                  </label>
                  <label htmlFor='propio' className='form-control'>
                    <CustomCheckbox type='radio' name='e' id='propio' value='Local propio' onChange={handleChange} />
                    Local propio
                  </label>
              </FormCheckBox>

            <FormMessage>
              <label htmlFor='message'>Déjanos cualquier comentario adicional que consideres importante:</label>
              <textarea placeholder='Comentario adicional' name='mensaje' value={form.mensaje} onChange={handleChange} required  />
            </FormMessage>
            <FormTermsAndConditions>
              <label htmlFor='terms'> 
              <CustomCheckbox type='checkbox' id='terms'  name='terminos' onChange={handleCheck} value={form.terminos} />
              {t('contact.lbl-termsAndConditions')}
              </label>
            </FormTermsAndConditions>

          <ButtonContainer>
            <ButtonSend disabled={loading}>{loading ? 'ENVIANDO...' : t('contact.btn-send')}</ButtonSend>
          </ButtonContainer>
          </Form>
        </FormContainer>
        <ImgContainer>
          <img src={contactImg} alt="" />
        </ImgContainer>
      </Wrapper>
    </Container>
  )
}

export default Afiliados;